import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import calendar from './calendar.js'

export default contract({
  calendar: array([
    calendar
  ])
})
